import Layout from "../../components/Layout/Layout";
import React from "react";
import AccountServices from "../../services/AccountServices";
import { useEffect } from "react";
import { convert } from "./../../utils/convertDate";
import fire from "./../../utils/Toastr";
import { useReactState } from "./../../utils/useReactState";
import Spinner from "./../../utils/Spinner";

export default function ViewAccount() {
  const id = new URLSearchParams(window.location.search).get("id");
  let state = useReactState({
    acct: {},
    adminType: "",
    loader: false,
  });

  const getAcct = async () => {
    const accts = await AccountServices.viewAccout(id);
    state.acct = accts.data;
    var details = sessionStorage.getItem("user");
    var userDetails = JSON.parse(details);
    var type = userDetails.adminType;
    state.adminType = type;
  };
  const removePnd = async () => {
    state.loader = true;
    if (state.adminType.toLowerCase() === "maker") {
      const resp = await AccountServices.removeRestriction(id.toString());
      if (!resp) {
        state.loader = false;
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else if (state.adminType.toLowerCase() === "checker") {
      const resp = await AccountServices.removeRestriction(id);
      if (!resp) {
        state.loader = false;
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }

      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
    state.loader = false;
  };
  useEffect(() => {
    getAcct();
  }, []);
  return (
    <>
      <Layout pageTag={"account"} current={"/accounts"}>
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto">
              <div className="py-4">
                <div className="flex justify-center">
                  <h4 className="font-bold">
                    {state.acct.lastName} {state.acct.firstName} <br />{" "}
                    <span className="font-thin">
                      {state.acct.accountNumber}
                    </span>
                  </h4>
                </div>
                <div className="px-4 sm:px-6 lg:px-8">
                  <div className="sm:flex sm:items-center">
                    {state.acct.pndLifted === false ? (
                      <div className="sm:flex-auto flex justify-end">
                        <button
                          type="button"
                          onClick={removePnd}
                          className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          {state.loader ? <Spinner /> : "Unblock Account"}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-8 flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                        <form>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <div className="px-6">
                                <h4>NAMES</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="prefix"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Title
                                      <span className="text-red-600">*</span>
                                    </label>
                                    <p className="font-bold">
                                      {state.acct.prefix}
                                    </p>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="firstName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      First name{" "}
                                      <span className="text-red-600">*</span>
                                    </label>
                                    <p className="font-bold">
                                      {state.acct.firstName}
                                    </p>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="otherNames"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Middle Name{" "}
                                      <span className="text-red-600">*</span>
                                    </label>
                                    <p className="font-bold">
                                      {state.acct.otherNames}
                                    </p>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="lastName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Last Name{" "}
                                      <span className="text-red-600">*</span>
                                    </label>
                                    <p className="font-bold">
                                      {state.acct.lastName}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <div className="px-6">
                                <h4>PERSONAL INFORMATION</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="lastName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Surname{" "}
                                      <span className="text-red-600">*</span>
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="lastName"
                                        id="lastName"
                                        value={state.acct.lastName}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="firstName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      First Name{" "}
                                      <span className="text-red-600">*</span>
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="firstName"
                                        id="firstName"
                                        value={state.acct.firstName}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="dob"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Date of Birth
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="dob"
                                        id="dob"
                                        value={convert(state.acct.dob)}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="gender"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Gender
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="gender"
                                        id="gender"
                                        value={state.acct.gender}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="maritalStatus"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Marital Status
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="maritalStatus"
                                        id="maritalStatus"
                                        value={state.acct.maritalStatus}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="mother"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Mother's Maiden Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="mother"
                                        id="mother"
                                        value={state.acct.motherMaidenName}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="nin"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      NIN
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="nin"
                                        id="nin"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="phone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Phone Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        value={state.acct.phoneNumber}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Email
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="email"
                                        id="email"
                                        value={state.acct.email}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="nationality"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Nationality
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="nationality"
                                        id="nationality"
                                        value={state.acct.nationality}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      State of Origin
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Local Government Area
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Tax Identification Number(TIN)
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Employee Identification Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Religion
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <div className="px-6">
                                <h4>ACCOUNT INFORMATION</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="accountNumber"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Account Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="accountNumber"
                                        id="first-name"
                                        value={state.acct.accountNumber}
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="accountType"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Account Type
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="accountType"
                                        id="accountType"
                                        value={state.acct.accountClass}
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="accountCcy"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Account Currency
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="accountCcy"
                                        id="accountCCy"
                                        value={state.acct.accountCcy}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/*Contact details form */}
                              <div className="px-6">
                                <h4>Contact Details</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Street Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Street Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Nearest Busstop
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      City/Town
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Local Government
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="state"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      State
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="state"
                                        id="state"
                                        value={state.acct.user}
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-6">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Mailing Address
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/*Means of identification form */}
                              <div className="px-6">
                                <h4>Means of Identification</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Identification Type
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Identification Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      ID Issue Date
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/*Account Services form */}
                              <div className="px-6">
                                <h4>Account Services</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Card Preferences
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Electronic Banking References
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Transaction Alert Preferences
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <div className="px-6">
                                <h4>NEXT OF KIN</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Title
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Surname
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      First Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Middlle Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Date of Birth
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="date"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Email
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Gender
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Relationship
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Mobile Number 1
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Mobile Number 2
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      House Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Street Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      City/ Town
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Local Government Area
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Nearest Bus-stop
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      State
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <div className="px-6">
                                <h4>Employment Details</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Employment Status
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Employers Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Date of Employment
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="first-name"
                                        id="first-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Street Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Street Name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      City/Town
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Nearest Bus-stop
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Nature of Occupation
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Office Phone Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Fax Number
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="last-name"
                                        id="last-name"
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
